import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _possibleConstructorReturn from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/createClass";
import LRUCache from 'lru-cache';
import { BaseSource } from './basesource';
import { AbortError, AggregateError, wait, zip } from '../utils';
var Block = /*#__PURE__*/function () {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {ArrayBuffer} [data]
   */
  function Block(offset, length) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, Block);
    this.offset = offset;
    this.length = length;
    this.data = data;
  }

  /**
   * @returns {number} the top byte border
   */
  _createClass(Block, [{
    key: "top",
    get: function get() {
      return this.offset + this.length;
    }
  }]);
  return Block;
}();
var BlockGroup =
/**
 *
 * @param {number} offset
 * @param {number} length
 * @param {number[]} blockIds
 */
function BlockGroup(offset, length, blockIds) {
  _classCallCheck(this, BlockGroup);
  this.offset = offset;
  this.length = length;
  this.blockIds = blockIds;
};
export var BlockedSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(BlockedSource, _BaseSource);
  /**
   *
   * @param {Source} source The underlying source that shall be blocked and cached
   * @param {object} options
   */
  function BlockedSource(source) {
    var _this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$blockSize = _ref.blockSize,
      blockSize = _ref$blockSize === void 0 ? 65536 : _ref$blockSize,
      _ref$cacheSize = _ref.cacheSize,
      cacheSize = _ref$cacheSize === void 0 ? 100 : _ref$cacheSize;
    _classCallCheck(this, BlockedSource);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockedSource).call(this));
    _this.source = source;
    _this.blockSize = blockSize;
    _this.blockCache = new LRUCache({
      max: cacheSize
    });

    // mapping blockId -> Block instance
    _this.blockRequests = new Map();

    // set of blockIds missing for the current requests
    _this.blockIdsToFetch = new Set();
    return _this;
  }
  _createClass(BlockedSource, [{
    key: "fetch",
    /**
     *
     * @param {basesource/Slice[]} slices
     */
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(slices, signal) {
        var cachedBlocks, blockRequests, missingBlockIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref8, offset, length, top, fileSize, firstBlockOffset, current, _blockId2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _blockId3, _block, cachedBlock, results, retriedBlockRequests, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref5, _ref4, _blockId, result, rejected, reason, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, blockId, block, values, requiredBlocks, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _ref9, _ref7, _blockId4, _block2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedBlocks = new Map();
                blockRequests = new Map();
                missingBlockIds = new Set();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 6;
                for (_iterator = slices[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _ref8 = _step.value;
                  offset = _ref8.offset;
                  length = _ref8.length;
                  top = offset + length;
                  fileSize = this.fileSize;
                  if (fileSize !== null) {
                    top = Math.min(top, fileSize);
                  }
                  firstBlockOffset = Math.floor(offset / this.blockSize) * this.blockSize; // chunk the current slice into blocks
                  for (current = firstBlockOffset; current < top; current += this.blockSize) {
                    // check if the block is cached, being requested or still missing
                    _blockId2 = Math.floor(current / this.blockSize);
                    if (this.blockCache.has(_blockId2)) {
                      cachedBlocks.set(_blockId2, this.blockCache.get(_blockId2));
                    } else if (this.blockRequests.has(_blockId2)) {
                      blockRequests.set(_blockId2, this.blockRequests.get(_blockId2));
                    } else if (this.blockIdsToFetch.has(_blockId2)) {
                      missingBlockIds.add(_blockId2);
                    } else {
                      this.blockIdsToFetch.add(_blockId2);
                      missingBlockIds.add(_blockId2);
                    }
                  }
                }

                // allow additional block requests to accumulate
                _context.next = 14;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;
              case 14:
                _context.prev = 14;
                _context.prev = 15;
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              case 17:
                _context.prev = 17;
                if (!_didIteratorError) {
                  _context.next = 20;
                  break;
                }
                throw _iteratorError;
              case 20:
                return _context.finish(17);
              case 21:
                return _context.finish(14);
              case 22:
                _context.next = 24;
                return wait();
              case 24:
                this.fetchBlocks(signal);
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 28;
                _iterator2 = missingBlockIds[Symbol.iterator]();
              case 30:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 46;
                  break;
                }
                _blockId3 = _step2.value;
                _block = this.blockRequests.get(_blockId3);
                cachedBlock = this.blockCache.get(_blockId3);
                if (!_block) {
                  _context.next = 38;
                  break;
                }
                blockRequests.set(_blockId3, _block);
                _context.next = 43;
                break;
              case 38:
                if (!cachedBlock) {
                  _context.next = 42;
                  break;
                }
                cachedBlocks.set(_blockId3, cachedBlock);
                _context.next = 43;
                break;
              case 42:
                throw new Error("Block ".concat(_blockId3, " is not in the block requests"));
              case 43:
                _iteratorNormalCompletion2 = true;
                _context.next = 30;
                break;
              case 46:
                _context.next = 52;
                break;
              case 48:
                _context.prev = 48;
                _context.t1 = _context["catch"](28);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;
              case 52:
                _context.prev = 52;
                _context.prev = 53;
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              case 55:
                _context.prev = 55;
                if (!_didIteratorError2) {
                  _context.next = 58;
                  break;
                }
                throw _iteratorError2;
              case 58:
                return _context.finish(55);
              case 59:
                return _context.finish(52);
              case 60:
                _context.next = 62;
                return Promise.allSettled(Array.from(blockRequests.values()));
              case 62:
                results = _context.sent;
                if (!results.some(function (result) {
                  return result.status === 'rejected';
                })) {
                  _context.next = 117;
                  break;
                }
                retriedBlockRequests = new Set();
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 68;
                for (_iterator3 = zip(blockRequests.keys(), results)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  _ref5 = _step3.value;
                  _ref4 = _slicedToArray(_ref5, 2);
                  _blockId = _ref4[0];
                  result = _ref4[1];
                  rejected = result.rejected, reason = result.reason;
                  if (rejected) {
                    // push some blocks back to the to-fetch list if they were
                    // aborted, but only when a different signal was used
                    if (reason.name === 'AbortError' && reason.signal !== signal) {
                      this.blockIdsToFetch.add(_blockId);
                      retriedBlockRequests.add(_blockId);
                    }
                  }
                }

                // start the retry of some blocks if required
                _context.next = 76;
                break;
              case 72:
                _context.prev = 72;
                _context.t2 = _context["catch"](68);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t2;
              case 76:
                _context.prev = 76;
                _context.prev = 77;
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              case 79:
                _context.prev = 79;
                if (!_didIteratorError3) {
                  _context.next = 82;
                  break;
                }
                throw _iteratorError3;
              case 82:
                return _context.finish(79);
              case 83:
                return _context.finish(76);
              case 84:
                if (!(this.blockIdsToFetch.length > 0)) {
                  _context.next = 117;
                  break;
                }
                this.fetchBlocks(signal);
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context.prev = 89;
                _iterator4 = retriedBlockRequests[Symbol.iterator]();
              case 91:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context.next = 100;
                  break;
                }
                blockId = _step4.value;
                block = this.blockRequests.get(blockId);
                if (block) {
                  _context.next = 96;
                  break;
                }
                throw new Error("Block ".concat(blockId, " is not in the block requests"));
              case 96:
                blockRequests.set(blockId, block);
              case 97:
                _iteratorNormalCompletion4 = true;
                _context.next = 91;
                break;
              case 100:
                _context.next = 106;
                break;
              case 102:
                _context.prev = 102;
                _context.t3 = _context["catch"](89);
                _didIteratorError4 = true;
                _iteratorError4 = _context.t3;
              case 106:
                _context.prev = 106;
                _context.prev = 107;
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }
              case 109:
                _context.prev = 109;
                if (!_didIteratorError4) {
                  _context.next = 112;
                  break;
                }
                throw _iteratorError4;
              case 112:
                return _context.finish(109);
              case 113:
                return _context.finish(106);
              case 114:
                _context.next = 116;
                return Promise.allSettled(Array.from(blockRequests.values()));
              case 116:
                results = _context.sent;
              case 117:
                if (!results.some(function (result) {
                  return result.status === 'rejected';
                })) {
                  _context.next = 121;
                  break;
                }
                if (!(signal && signal.aborted)) {
                  _context.next = 120;
                  break;
                }
                throw new AbortError('Request was aborted');
              case 120:
                throw new AggregateError(results.filter(function (result) {
                  return result.status === 'rejected';
                }).map(function (result) {
                  return result.reason;
                }), 'Request failed');
              case 121:
                // extract the actual block responses
                values = results.map(function (result) {
                  return result.value;
                }); // create a final Map, with all required blocks for this request to satisfy
                requiredBlocks = new Map(zip(Array.from(blockRequests.keys()), values));
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context.prev = 126;
                for (_iterator5 = cachedBlocks[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  _ref9 = _step5.value;
                  _ref7 = _slicedToArray(_ref9, 2);
                  _blockId4 = _ref7[0];
                  _block2 = _ref7[1];
                  requiredBlocks.set(_blockId4, _block2);
                }

                // TODO: satisfy each slice
                _context.next = 134;
                break;
              case 130:
                _context.prev = 130;
                _context.t4 = _context["catch"](126);
                _didIteratorError5 = true;
                _iteratorError5 = _context.t4;
              case 134:
                _context.prev = 134;
                _context.prev = 135;
                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return();
                }
              case 137:
                _context.prev = 137;
                if (!_didIteratorError5) {
                  _context.next = 140;
                  break;
                }
                throw _iteratorError5;
              case 140:
                return _context.finish(137);
              case 141:
                return _context.finish(134);
              case 142:
                return _context.abrupt("return", this.readSliceData(slices, requiredBlocks));
              case 143:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21], [28, 48, 52, 60], [53,, 55, 59], [68, 72, 76, 84], [77,, 79, 83], [89, 102, 106, 114], [107,, 109, 113], [126, 130, 134, 142], [135,, 137, 141]]);
      }));
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
    /**
     *
     * @param {AbortSignal} signal
     */
  }, {
    key: "fetchBlocks",
    value: function fetchBlocks(signal) {
      var _this2 = this;
      // check if we still need to
      if (this.blockIdsToFetch.size > 0) {
        (function () {
          var groups = _this2.groupBlocks(_this2.blockIdsToFetch);

          // start requesting slices of data
          var groupRequests = _this2.source.fetch(groups, signal);
          var _loop = function _loop(groupIndex) {
            var group = groups[groupIndex];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;
            try {
              var _loop2 = function _loop2() {
                var blockId = _step6.value;
                // make an async IIFE for each block
                var blockRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var response, blockOffset, o, t, data, block;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return groupRequests;
                        case 3:
                          _context2.t0 = groupIndex;
                          response = _context2.sent[_context2.t0];
                          blockOffset = blockId * _this2.blockSize;
                          o = blockOffset - response.offset;
                          t = Math.min(o + _this2.blockSize, response.data.byteLength);
                          data = response.data.slice(o, t);
                          block = new Block(blockOffset, data.byteLength, data);
                          _this2.blockCache.set(blockId, block);
                          return _context2.abrupt("return", block);
                        case 14:
                          _context2.prev = 14;
                          _context2.t1 = _context2["catch"](0);
                          if (_context2.t1.name === 'AbortError') {
                            // store the signal here, we need it to determine later if an
                            // error was caused by this signal
                            _context2.t1.signal = signal;
                          }
                          throw _context2.t1;
                        case 18:
                          _context2.prev = 18;
                          _this2.blockRequests.delete(blockId);
                          return _context2.finish(18);
                        case 21:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 14, 18, 21]]);
                }))();
                _this2.blockRequests.set(blockId, blockRequest);
              };
              for (var _iterator6 = group.blockIds[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                _loop2();
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          };
          for (var groupIndex = 0; groupIndex < groups.length; ++groupIndex) {
            _loop(groupIndex);
          }
          _this2.blockIdsToFetch.clear();
        })();
      }
    }
    /**
     *
     * @param {Set} blockIds
     * @returns {BlockGroup[]}
     */
  }, {
    key: "groupBlocks",
    value: function groupBlocks(blockIds) {
      var sortedBlockIds = Array.from(blockIds).sort(function (a, b) {
        return a - b;
      });
      if (sortedBlockIds.length === 0) {
        return [];
      }
      var current = [];
      var lastBlockId = null;
      var groups = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;
      try {
        for (var _iterator7 = sortedBlockIds[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var blockId = _step7.value;
          if (lastBlockId === null || lastBlockId + 1 === blockId) {
            current.push(blockId);
            lastBlockId = blockId;
          } else {
            groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
            current = [blockId];
            lastBlockId = blockId;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
      groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
      return groups;
    }
    /**
     *
     * @param {Slice[]} slices
     * @param {Map} blocks
     */
  }, {
    key: "readSliceData",
    value: function readSliceData(slices, blocks) {
      var _this3 = this;
      return slices.map(function (slice) {
        var top = slice.offset + slice.length;
        var blockIdLow = Math.floor(slice.offset / _this3.blockSize);
        var blockIdHigh = Math.floor((slice.offset + slice.length) / _this3.blockSize);
        var sliceData = new ArrayBuffer(slice.length);
        var sliceView = new Uint8Array(sliceData);
        for (var blockId = blockIdLow; blockId <= blockIdHigh; ++blockId) {
          var block = blocks.get(blockId);
          var delta = block.offset - slice.offset;
          var topDelta = block.top - top;
          var blockInnerOffset = 0;
          var rangeInnerOffset = 0;
          var usedBlockLength = void 0;
          if (delta < 0) {
            blockInnerOffset = -delta;
          } else if (delta > 0) {
            rangeInnerOffset = delta;
          }
          if (topDelta < 0) {
            usedBlockLength = block.length - blockInnerOffset;
          } else {
            usedBlockLength = top - block.offset - blockInnerOffset;
          }
          var blockView = new Uint8Array(block.data, blockInnerOffset, usedBlockLength);
          sliceView.set(blockView, rangeInnerOffset);
        }
        return sliceData;
      });
    }
  }, {
    key: "fileSize",
    get: function get() {
      return this.source.fileSize;
    }
  }]);
  return BlockedSource;
}(BaseSource);